<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/po">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              PO Manifest
              <small class="m-display-block m-text-small">{{
                data.manifest.no_po
              }}</small>
            </div>
            <a-popover v-model="visiblemenupopover" slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    :disabled="!data.print_btn"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                    >Manifest</a-button
                  >
                </li>
                <li>
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.manifest.prepared_by &&
                          data.revised_flag
                        ) && !data.cancel_sts
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="data.cancel_btn=='disabled'"
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                    <a-button
                      @click="handleclosetrans"
                      :disabled="data.close_btn!='enabled'"
                      type="primary"
                      icon="check"
                      >Close</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc">{{
                    moment(data.manifest.tgl_po, getStandartFormatDate).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.manifest.prepared_by
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No PP</span>
                  <span class="m-list-desc">{{ data.manifest.no_pp }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Supplier</span>
                  <span class="m-list-desc">{{ data.manifest.kepada }} <br/>
                    (PKP : {{ data.manifest.ispkp }} , Domestik : {{ data.manifest.domestik }})</span>
                </li>
                <li>
                  <span class="m-list-title" for>Delivery Address</span>
                  <span class="m-list-desc">{{ data.manifest.lokasi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Document Needed</span>
                  <ul v-for="(db, index) in data.dokumen_butuh" :key="index">
                    <li class="m-list-desc" v-if="db !== ''">{{ db }}</li>
                  </ul>
                  <span v-if="handleDokumenButuh()" class="m-list-desc" for
                    >-</span
                  >
                </li>
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc">{{ data.manifest.deskripsi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Need QC</span>
                  <span class="m-list-desc">{{
                    data.manifest.inc_qc == "1" ? "Yes" : "No"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.catatan }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card v-if="getScreen" style="overflow: auto" class="margin-bottom">
            <div slot="title">PO Detail</div>
            <div slot="extra">
              <!-- <a-button
                @click="handleviewhistPaymentrefund"
                type="default"
                size="small"
                class="margin-right-small"
                icon="undo"
                v-if="visiblehistorypaymentrefund"
              >
                History
              </a-button> -->
            </div>
            <div class="m-card-body divOverflow">
              <!-- style="overflow: auto;"
              class="listOverflow"   style="overflow: auto;"-->
              <a-list
                item-layout="vertical"
                :data-source="dtabel"
                :pagination="pagination"
              >
                <a-list-item
                  slot="renderItem"
                  key="item.id_dtl"
                  slot-scope="item, index"
                >
                  <a-list-item-meta>
                    <div slot="title">
                      <p style="font-size: 14px">
                        {{ item.nama_barang }}<br />{{ item.nama_barang_pp
                        }}<br />
                        PP Dtl :
                        <i
                          >({{ item.nama_barang_pp }} /
                          {{ item.kode_anggaran }})</i
                        >
                      </p>
                    </div>
                    <div slot="description" class="margin-remove">
                      <div class="m-display-flex space-between">
                        <span v-if="penerimaan.length > 0"
                          >{{ item.jumlah }}&nbsp;{{ item.satuan }} |
                          {{ penerimaan[index].jumlah_isi }}&nbsp;Item</span
                        >
                        <span v-else
                          >{{ item.jumlah }}&nbsp;{{ item.satuan }} |
                          1&nbsp;Item</span
                        >
                        <div>
                          <h4 class="margin-remove m-text-align right">
                            @ {{ formatCurrency(currency, item.harga) }}
                          </h4>
                        </div>
                      </div>
                      <h3 class="margin-remove m-text-align right">
                        Total Bill :
                        {{ formatCurrency(currency, item.total_harga) }}
                      </h3>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
            <div class="m-price-total">
              <h3 class="margin-remove m-text-align right">
                Total : {{ formatCurrency(currency, data.total.subTotal) }}
              </h3>
              <!-- <h3
                class="margin-remove m-text-align right"
              >TAX ({{pajak}}) : {{formatCurrency(currency,data.total.nilaiPajak)}}</h3>
              <h3 v-if="data.total.shipping"
                class="margin-remove m-text-align right"
              >Shipping Cost : {{formatCurrency(currency,data.total.shipping)}}</h3> -->

              <h3
                v-for="(item, index) in dlist"
                :key="index"
                class="margin-remove m-text-align right"
              >
                {{ item.nama_barang }} 
                <template v-if="item.tax_type">
                <i>{{item.tax_type && item.tax_type.includes("pph") ? (item.tax_bearer=="1" ? "(Supplier Tax Bearer)": "(Infoglobal Tax Bearer)") : ""}}</i>
                </template> : 
                <!-- {{ item.persen !== null ? "(" + item.persen + "%)" : "" }} -->

                <!-- {{ item.persen !== null ? "(" + item.persen + "%) : " : " : " }} -->
                {{ item.kategori == "1" || (item.kategori == "2" && item.tax_bearer=="1") ? "-" : "" }}
                {{ formatCurrency(currency, item.total_harga) }}
              </h3>
              
              <div style="display: flex;flex-direction: row-reverse">
                
                <h3 class="margin-remove m-text-align right" v-if="displaylistrefund">
                  Refund : {{ formatCurrency(currency, data.total.refundTotal) }}
                </h3>

                <a-button
                class="margin-top"
                style="margin-right: 10px"
                @click="handleViewclosetrans"
                type="default"
                icon="eye"
                size="small"
                >View</a-button>
              </div>

              <a-statistic
                title="Total Bill"
                :value="formatCurrency(currency, data.total.grandTotal)"
                class="margin-top m-text-align right"
              />
            </div>
            <i v-if="anyPPH" style="color:red">* PPh is not calculated </i>
          </a-card>
          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 slot="header" class="margin-remove">PO Detail</h4>
                <div>
                  <!-- <a-button
                    @click="handleviewhistPaymentrefund"
                    type="default"
                    size="small"
                    class="margin-right-small"
                    icon="undo"
                    v-if="visiblehistorypaymentrefund"
                  >
                    History
                  </a-button> -->
                </div>
              </div>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <span slot="item_PN" slot-scope="item_PN">
                  <b>{{ item_PN.nama_barang }}</b
                  ><br />
                  {{
                    item_PN.item_pn || item_PN.item_pn !== ""
                      ? "PN : " +
                        (item_PN.item_pn == null ? "-" : item_PN.item_pn)
                      : ""
                  }}<br />{{ "( "+item_PN.type_item +" )"}}<br />
                </span>
                <span slot="ppdtl" slot-scope="ppdtl">
                  {{ ppdtl.nama_barang_pp }}<br />
                  <i> {{ ppdtl.kode_anggaran }}</i>
                </span>
                <span slot="inventory" slot-scope="item">
                  {{ item.isinventaris=='1' ? "Yes" : "No" }}
                </span>
                <span slot="unit_price" slot-scope="unit_price">
                  <CurrencyJustified
                    :currencyValue="unit_price.curr"
                    :valueNumber="unit_price.val === 0 ? 0.0 : unit_price.val"
                  />
                </span>
                <span slot="amount" slot-scope="amount">
                  <CurrencyJustified
                    :currencyValue="amount.curr"
                    :valueNumber="amount.val"
                  />
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="10" :order="1" class="m-text-align left"
                      ><b>Total</b></a-col
                    >
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :deci2="true"
                        v-if="data.total.totalitem"
                        :currencyValue="currency"
                        :valueNumber="data.total.totalitem"
                      />
                    </a-col>
                  </a-row>

                  <a-row
                    type="flex"
                    v-for="(item, index) in dlist"
                    :key="index"
                  >
                    <a-col :span="10" :order="1" class="m-text-align left">
                      {{ item.nama_barang }} 
                      <template v-if="item.tax_type">
                        <br/>
                      <i>{{item.tax_type && item.tax_type.includes("pph") ? (item.tax_bearer=="1" ? "(Supplier Tax Bearer)": "(Infoglobal Tax Bearer)") : ""}}</i>
                      </template>
                      {{ item.persen !== null ? "(" + item.persen + "%)" : "" }}
                    </a-col>
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align right m-text-bold"
                    >
                      <!-- {{ item.kategori == "1" || (item.kategori == "2" && item.tax_bearer=="1") ? "-" : "" }} -->
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :deci2="true"
                        v-if="item.total_harga"
                        :currencyValue="currency"
                        :valueNumber="item.total_harga"
                      />
                    </a-col>
                  </a-row>

                  <a-divider class="margin-small" />
                  <a-row type="flex">
                    <a-col :span="10" :order="1" class="m-text-align left"
                      ><b>Total Bill</b></a-col
                    >
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :deci2="true"
                        v-if="data.total.grandTotal"
                        :currencyValue="currency"
                        :valueNumber="data.total.grandTotal"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex" v-if="displaylistrefund">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Refund</a-col
                    >
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :deci2="true"
                        v-if="data.total.refundTotal"
                        :currencyValue="currency"
                        :valueNumber="data.total.refundTotal"
                      />
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      &nbsp;
                      <a-button
                      @click="handleViewclosetrans"
                      type="default"
                      icon="eye"
                      size="small"
                      >View</a-button
                    >
                    </a-col>
                  </a-row>
                </div>
              </a-table>
              <i v-if="anyPPH" style="color:red">* PPh is not calculated </i>
            </a-collapse-panel>
          </a-collapse>
          <template v-if="!getScreen">
            <a-card
              class="margin-top"
              :loading="loading"
              v-if="data.jenis === 'Verifikator' || data.jenis === 'Approve'"
            >
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select
                    v-decorator="[
                      'aksi',
                      {
                        rules: [{ required: true }],
                        initialValue: data.aksi[0].aksi,
                      },
                    ]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-card>

            <a-card class="margin-top" v-else-if="data.jenis === 'Transfer'">
              <div slot="title">
                <h4 class="margin-remove">Manifest Actions</h4>
                <small
                  v-if="data.jenis == 'Transfer' && !data.status_transfer"
                  style="color: red"
                  >(Funding has not been set)
                </small>
              </div>
              <div class="m-text-align right margin-remove" slot="extra">
                <h5 class="m-text-align right margin-remove">
                  remaining balance
                </h5>
                <a-tag color="green" class="m-text-align right margin-remove">{{
                  formatCurrency(currency, sisa_tf)
                }}</a-tag>
              </div>
              <template
                v-if="!(data.jenis == 'Transfer' && !data.status_transfer)"
              >
                <a-form :form="form">
                  <a-row :gutter="16">
                    <a-form-item label="Status">
                      <a-select
                        @change="onChangeStatus"
                        v-decorator="[
                          'status',
                          {
                            rules: [{ required: true }],
                            initialValue: data.aksi[0].aksi,
                          },
                        ]"
                      >
                        <a-select-option
                          v-for="da in data.aksi"
                          :key="da.aksi"
                          >{{ da.aksi }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Transfer Date">
                      <a-date-picker
                        placeholder="Select Date"
                        :format="dateFormat"
                        v-decorator="[
                          'tgl_tf',
                          { rules: [{ required: true }] },
                        ]"
                      />
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                      <a-upload
                        :fileList="fileList"
                        :disabled="fileList.length > 0"
                        v-decorator="[
                          'file_transfer',
                          { rules: [{ required: reqFileTf }] },
                        ]"
                        accept=".jpg, .png, .pdf"
                        :remove="handleRemove"
                        :beforeUpload="beforeUpload"
                      >
                        <a-button>
                          <a-icon type="upload" />Select File
                        </a-button>
                      </a-upload>
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Transfer Value">
                      <a-checkbox
                        :defaultChecked="true"
                        @change="onchangeNilaiTf"
                        :checked="checkTransferValue"
                        >Transfer value according to remaining
                        balance</a-checkbox
                      >
                      <a-input-number
                        :min="0.1"
                        :max="sisa_tf"
                        class="m-display-block"
                        v-decorator="[
                          'value_transferan',
                          {
                            rules: [{ required: true }],
                            initialValue: temp_sisa_tf,
                          },
                        ]"
                        :disabled="disableNilaiTf"
                      ></a-input-number>
                    </a-form-item>

                    <a-form-item label="Note">
                      <a-textarea
                        placeholder="Write the note here ... "
                        :rows="4"
                        v-decorator="[
                          'catatan',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                  </a-row>
                  <a-form-item :wrapper-col="{ span: 24 }">
                    <a-button
                      @click="handleActionConfirm"
                      block
                      type="primary"
                      html-type="submit"
                      >Save</a-button
                    >
                  </a-form-item>
                </a-form>
              </template>
            </a-card>
          </template>
          <a-collapse
            class="margin-top"
            activeKey="1"
            v-if="!getScreen && getShippingflag"
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Shipment Status</h4>
                <a-button
                  @click="addShipmentStatus"
                  type="default"
                  class="margin-right-small"
                  v-if="
                    data.jenis === 'Manifest' &&
                    (data.manifest.prepared_by === getAuth.username ||
                      getAuth.divisi[0] == 'Purchasing') &&
                    getLastStatusShipment &&
                    getShippingflag &&
                    btnShipment
                  "
                  icon="plus"
                >
                  Add
                </a-button>
              </div>

              <div v-for="(sts, index) in status_shipment" :key="index">
                <a-card style="margintop: 5px">
                  <a-timeline class="m-timeline">
                    <div class="m-display-flex space-between align-middle">
                      <h4>{{ sts.surat_jalan }}</h4>
                      <div style="marginbottom: 5px">
                        <a-button
                          v-if="
                            status_shipment[index].manifest_receive_dtl
                              .length === 0
                          "
                          @click="addShipmentDeliver(sts)"
                          type="default"
                          size="small"
                          class="margin-right-small"
                        >
                          Deliver
                        </a-button>
                        <a-button
                          v-if="
                            status_shipment[index].manifest_receive_dtl
                              .length === 0
                          "
                          @click="addShipmentReceive(sts, dataDetailShipment)"
                          type="default"
                          size="small"
                          class="margin-right-small"
                        >
                          Receive
                        </a-button>
                      </div>
                    </div>
                    <a-timeline-item
                      v-for="workflow in sts.delivered"
                      :key="workflow.po_deli_dtl_id"
                    >
                      <div class="m-timeline-body">
                        <h4 class="margin-remove">
                          {{ workflow.nama_kurir }} - {{ workflow.no_resi }}
                        </h4>

                        <div class="m-display-flex space-between align-middle">
                          <h4 class="margin-remove" v-if="workflow.deli_dt">
                            {{
                              moment(
                                workflow.deli_dt,
                                getStandartFormatDate
                              ).format(getDefaultDateFormat)
                            }}
                          </h4>
                          <a-tag
                            color="orange"
                            @click="
                              openWindowCopy(
                                workflow.link_tracking,
                                workflow.no_resi
                              )
                            "
                            >Delivered</a-tag
                          >
                        </div>
                        <span class="m-text-small" v-if="workflow.catatan">{{
                          workflow.catatan
                        }}</span>
                        <span class="m-text-small" v-else
                          >Tidak Ada Catatan</span
                        >
                      </div>
                    </a-timeline-item>

                    <a-timeline-item
                      v-if="sts.receive_status.constructor === Object"
                    >
                      <div class="m-timeline-body">
                        <h4 class="margin-remove">
                          {{ sts.receive_status.nama_kurir }} -
                          {{ sts.receive_status.nomor_resi }}
                        </h4>
                        <div class="m-display-flex space-between align-middle">
                          <h4 class="margin-remove">
                            {{
                              moment(
                                sts.receive_status.tanggal,
                                getStandartFormatDate
                              ).format(getDefaultDateFormat)
                            }}
                          </h4>
                          <a-tag
                            color="green"
                            @click="
                              showManifestShipment(
                                sts.manifest_receive_hdr,
                                sts.manifest_receive_dtl
                              )
                            "
                            >{{ sts.receive_status.status }}</a-tag
                          >
                        </div>
                        <span
                          class="m-text-small"
                          v-if="sts.receive_status.catatan"
                          >{{ sts.receive_status.catatan }}</span
                        >
                        <span class="m-text-small" v-else
                          >Tidak Ada Catatan</span
                        >
                      </div>
                    </a-timeline-item>
                  </a-timeline>
                </a-card>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transfer Receipt</h4>
              </div>
              <ul class="m-list-wrapper bordered">
                <li
                  v-for="(dbt, index) in data.detailBuktiTransfer"
                  :key="index"
                >
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle nowrap"
                  >
                    <h4 class="margin-remove m-text-dots">
                      {{ moment(dbt.tgl_tf).format("DD-MM-YYYY") }} | {{ dbt.user_tf }}
                    </h4>
                    <a-upload
                      class="upload-custom"
                      :fileList="dbt.fileList"
                      @preview="handlePreview"
                    ></a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <div class="margin-top"></div>
                      <a-divider class="margin-small" />
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                  <div class="m-display-flex space-between align-middle">
                    <p slot="description">
                      {{ currency + ". " + dbt.value_tf }}
                    </p>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.manifest.prepared_by }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(
                          data.manifest.tgl_po,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="data.manifest.catatan">{{
                      data.manifest.catatan
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1"
            v-if="
              data.jenis === 'Manifest' ||
              data.jenis === 'Verifikator' ||
              data.jenis === 'Transfer'
            "
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Account Pay</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.ap">
                <Empty v-if="data.ap ? data.ap.length <= 0 : data.ap" />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <span class="margin-remove m-text-dots">
                        {{ item.title ? item.title : "-" }}
                      </span>
                      <a-button
                        @click="handleViewFile(item)"
                        icon="eye"
                        size="small"
                        >View</a-button
                      >
                    </div>
                    <div slot="description">
                      <a-row>
                        <a-col span="6">No Invoice</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.no_invoice }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Due Date</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.due_date }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Value</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{
                          formatCurrency(data.currency, item.value)
                        }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Catatan</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.description }}</a-col>
                        <!-- <Status :status="item.status_bkk" /> -->
                      </a-row>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1"
            v-if="
              data.jenis === 'Manifest' ||
              data.jenis === 'Verifikator' ||
              data.jenis === 'Transfer'
            "
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">File Attachment</h4>
                <div>
                  <a-button
                    @click="addLampiran"
                    type="default"
                    class="margin-right-small"
                  >
                    upload
                    <a-icon type="upload" />
                  </a-button>
                </div>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.lampiran">
                <Empty
                  v-if="
                    data.lampiran ? data.lampiran.length <= 0 : data.lampiran
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title">
                      <a
                        @click="handleDownload(item)"
                        class="margin-remove m-text-dots"
                      >
                        {{ item.jenis ? item.jenis : "-" }}
                      </a>
                    </div>
                    <div slot="description">
                      <div class="m-display-flex space-between nowrap">
                        <h4 class="margin-remove m-text-dots">
                          {{ item.fungsi }}
                        </h4>
                        <a-button
                          v-if="data.manifest.prepared_by === getAuth.username"
                          :disabled="item.source == 'assist'"
                          @click="handleRemoveExisting(item.id_po_doc)"
                          size="small"
                          type="danger"
                          icon="delete"
                        ></a-button>
                      </div>
                      {{ item.tanggal }} | {{ item.tlc }}
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleViews(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="
                        item.estimated_value && item.rest_api !== 'supplier'
                      "
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.estimated_value)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
      <template v-if="getScreen">
        <a-card
          class="margin-top"
          :loading="loading"
          v-if="data.jenis === 'Verifikator' || data.jenis === 'Approve'"
        >
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="4"
                v-decorator="['catatan']"
              />
            </a-form-item>
            <a-form-item label="Aksi">
              <a-select
                v-decorator="[
                  'aksi',
                  {
                    rules: [{ required: true }],
                    initialValue: data.aksi[0].aksi,
                  },
                ]"
              >
                <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                  item.aksi
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button
                @click="handleActionConfirm"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </a-form-item>
          </a-form>
        </a-card>

        <a-card class="margin-top" v-else-if="data.jenis === 'Transfer'">
          <div slot="title">
            Manifest Actions &nbsp;<i
              v-if="data.jenis == 'Transfer' && !data.status_transfer"
              style="color: red !important"
              >(Funding has not been set)</i
            >
          </div>
          <div slot="extra">
            <h5 class="m-text-align right margin-remove">remaining balance</h5>
            <a-tag color="green" class="m-text-align right margin-remove">{{
              formatCurrency(currency, sisa_tf)
            }}</a-tag>
          </div>
          <template v-if="!(data.jenis == 'Transfer' && !data.status_transfer)">
            <a-form :form="form">
              <a-row :gutter="16">
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length > 0"
                      v-decorator="[
                        'file_transfer',
                        { rules: [{ required: true }] },
                      ]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                      >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                      :min="0.1"
                      :max="sisa_tf"
                      class="m-display-block"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </template>
        </a-card>
      </template>
    </div>

    <a-modal
      :visible="visibleEditDtl"
      :title="editReceiveDtl.title"
      @cancel="handleCancelDtl"
      :maskClosable="false"
    >
      <div>
        <a-form :form="formeditRowDtl">
          <a-form-item label="Storage Location">
            <a-radio-group
              button-style="solid"
              @change="(e) => selectRadioUsedForReceive(e)"
              v-decorator="[
                'usedforReceive',
                {
                  rules: [{ required: true }],
                  initialValue: editReceiveDtl.opsi,
                },
              ]"
              :disabled="used_for_status && isAssetModal=='no'"
            >
              <a-radio-button value="unitkelola" v-if="editReceiveDtl.type_item=='1'"
                :disabled="editReceiveDtl.type_item=='1'"> Unit Manage </a-radio-button>
              <a-radio-button value="gudangreceive" v-if="editReceiveDtl.type_item=='0'"> Gudang </a-radio-button>
              <a-radio-button value="tlcreceive" :hidden="editReceiveDtl.type_item=='1'"> TLC </a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-if="editReceiveDtl.opsi === 'tlcreceive'">
            <a-select
              showSearch
              allowClear
              :filter-option="filterOptionTlcdtl"
              option-filter-prop="children"
              v-decorator="[
                'tlcEditDtl',
                {
                  rules: [{ required: true, message: 'TLC is required' }],
                  initialValue: editReceiveDtl.tlc,
                },
              ]"
            >
              <a-select-option
                v-for="item in getAllKaryawan"
                :key="item.tlc"
                :value="item.tlc"
                >{{ item.tlc }} - {{ item.nama }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-else-if="editReceiveDtl.opsi === 'gudangreceive'">
            <a-select
              showSearch
              allowClear
              :filter-option="filterOptionGudangdtl"
              option-filter-prop="children"
              v-decorator="[
                'gudangEditDtl',
                {
                  rules: [{ required: true, message: 'Gudang is required' }],
                  initialValue: editReceiveDtl.idgudang,
                },
              ]"
            >
              <a-select-option
                v-for="item in daftarGudang"
                :key="item.gudang_id"
                :value="item.gudang_id"
                >{{ item.gudang_nm }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-else>
            <a-select
              showSearch
              allowClear
              :filter-option="filterOptionUnitkelola"
              option-filter-prop="children"
              v-decorator="[
                'unitkelolaEditDtl',
                {
                  rules: [{ required: true, message: 'Unit Manage is required' }],
                  initialValue: editReceiveDtl.unit_kelola_id,
                },
              ]"
            >
              <a-select-option
                v-for="item in daftarUnitKelola"
                :key="item.aset_unit_id"
                :value="item.aset_unit_id"
                >{{ item.aset_unit_nm }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            v-if="editReceiveDtl.opsi != 'tlcreceive' && editReceiveDtl.type_item=='0'"
            label="Item Receive"
            :required="true"
            :message="'Please select item receive'"
          >
            <v-select
              clearable
              class="m-select"
              @input="handlePNitem"
              :options="dataPNitem"
              v-model="selectedPN"
              label="item_pn_concat"
            ></v-select>
          </a-form-item>
          <a-form-item
            v-if="editReceiveDtl.opsi != 'tlcreceive' && editReceiveDtl.type_item=='1'"
            label="Aset Receive"
            :required="true"
            :message="'Please select aset receive'"
          >
            <v-select
              taggable
              clearable
              class="m-select"
              @input="handlePNAset"
              :options="dataPNAset"
              v-model="selectedPNAset"
              label="item_pn_concat"
            ></v-select>
          </a-form-item>
          <!--:disabled="(selectedPNAset && selectedPNAset.aset_pn) ? true : false" -->
          <a-form-item label="PN Aset"
            v-if="editReceiveDtl.opsi != 'tlcreceive' && editReceiveDtl.type_item=='1'">
                <a-input
                  :min="0"
                  style="margin: -5px 0"
                  class="width-full"
                  :step="1"
                  v-decorator="[
                    'PNAset',
                    {
                      rules: [{ required: false }],
                      initialValue: editReceiveDtl.item_pn,
                    },
                  ]"
                />
              </a-form-item>
          <a-row :gutter="8" type="flex">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :order="1" class="m-text-align left">
              <a-form-item label="Qty :">
                <a-input-number
                  :min="0"
                  style="margin: -5px 0"
                  class="width-full"
                  :step="1"
                  v-decorator="[
                    'qtydtl',
                    {
                      rules: [{ required: true }],
                      initialValue: editReceiveDtl.qty,
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col
              :xs="{ span: 24 }" :lg="{ span: 12 }"
              :order="3"
              class="m-text-align left"
            >
                <a-form-item label="Unit PO :">
                <a-input
                  style="margin: -5px 0"
                  :step="1"
                  disabled
                  v-decorator="[
                    'unitdtl',
                    {
                      rules: [{ required: false }],
                      initialValue: editReceiveDtl.unit_po_receive,
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="8" type="flex" v-if="editReceiveDtl.opsi === 'gudangreceive' || editReceiveDtl.type_item=='1'">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :order="1" class="m-text-align left">
              <a-form-item label="Unit Price (IDR):" >
                <a-input-number
                  :disabled="editReceiveDtl.type_item=='1'"
                  :min="0"
                  style="margin: -5px 0"
                  class="width-full"
                  :step="1"
                  v-decorator="[
                    'unitpricedtl',
                    {
                      rules: [{ required: true }],
                      initialValue: editReceiveDtl.price_receive,
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col
              :xs="{ span: 24 }" :lg="{ span: 12 }"
              :order="2"
              class="m-text-align left"
            >
                <div :style="editReceiveDtl.type_item=='0' ? 'display:block;' : 'display:none;'">
                  <a-form-item label="Unit Item Master :">
                  <a-input
                    style="margin: -5px 0"
                    :step="1"
                    disabled
                    v-decorator="[
                      'unitmasterdtl',
                      {
                        rules: [{ required: false }],
                        initialValue: editReceiveDtl.unit_receive,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          Save
        </a-button>
      </template>
    </a-modal>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal
      v-model="visibleLampiran"
      @ok="addLampiran"
      :footer="null"
      @cancel="cancelLampiran"
    >
      <span slot="title">
        <a-icon type="reload" />&nbsp;Upload Attachments
      </span>

      <a-form :form="formLampiran">
        <a-form-item label="Document Type">
          <a-select v-decorator="['jenis', { rules: [{ required: true }] }]">
            <a-select-option value="COC">COC</a-select-option>
            <a-select-option value="Test Report">Test Report</a-select-option>
            <a-select-option value="Packing Report"
              >Packing Report</a-select-option
            >
            <a-select-option value="QC Report">QC Report</a-select-option>
            <a-select-option value="Other">Other</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Document Description">
          <a-input
            autocomplete="off"
            v-decorator="['fungsi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Upload Document File">
          <a-upload
            :remove="handleRemoveModal"
            v-decorator="[
              'file_list_lampiran',
              { rules: [{ required: true }] },
            ]"
            :fileList="fileListModalLampiran"
            :disabled="fileListModalLampiran.length > 0"
            :beforeUpload="beforeUploadModal"
          >
            <a-button> <a-icon type="upload" />Select File </a-button>
          </a-upload>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleUploadLampiran"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      :visible="visibleDpo"
      @ok="onClickItem"
      :footer="null"
      @cancel="cancelModalDpo"
    >
      <a-form :form="formDpo">
        <a-row>
          <a-form-item
            v-bind="formItemLayout"
            :label="'1' + modalListDpo.satuan"
          >
            <a-input-number
              :min="1"
              v-decorator="[
                'jumlah',
                {
                  rules: [{ required: true }],
                  initialValue: modalListDpo.jumlah_isi,
                },
              ]"
            ></a-input-number
            >Item
          </a-form-item>
        </a-row>

        <a-form-item label="Tanggal Penerimaan">
          <a-date-picker
            placeholder="Select Date"
            :format="dateFormat"
            v-decorator="[
              'tgl_terima',
              {
                rules: [{ required: true }],
                initialValue: modalListDpo.tgl_terima,
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Lokasi Gudang">
          <a-select
            v-decorator="[
              'id_gudang',
              {
                rules: [{ required: true }],
                initialValue: modalListDpo.nm_gudang,
              },
            ]"
            @change="handleGudangLokasi"
          >
            <a-select-option
              v-for="item in getAllGudang"
              :key="item.gudang_id"
              :value="item.gudang_id"
              >{{ item.gudang_nm }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handlePenerimaan"
            block
            type="danger"
            html-type="submit"
            >Set</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibleShipmentStatus"
      @ok="addShipmentStatus"
      :footer="null"
      @cancel="cancelShipmentStatus"
    >
      <span slot="title"> <a-icon type="reload" />&nbsp;Shipment Status </span>

      <a-form :form="formShipmentStatus">
        <a-form-item label="Carrier">
          <a-select
            showSearch
            v-decorator="['kurir', { rules: [{ required: true }] }]"
          >
            <a-select-option
              v-for="item in getAllKurir"
              :key="item.kurir_id"
              :value="item.kurir_id"
              >{{ item.nama_kurir }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item label="Tracking Number">
          <a-input
            autocomplete="off"
            v-decorator="['no_resi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Delivery Note">
          <a-input
            v-decorator="['delivery_note', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Delivering Date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['tgl_kirim', { rules: [{ required: true }] }]"
          />
        </a-form-item>

        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="3"
            v-decorator="['note', { rules: [{ required: false }] }]"
          />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleShipmentStatusDialog"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibleShipmentDeliver"
      :footer="null"
      @cancel="cancelDeliver"
    >
      <span slot="title"> <a-icon type="reload" />&nbsp;Shipment Status </span>

      <a-form :form="formShipmentDeliver">
        <a-form-item label="Carrier">
          <a-select
            showSearch
            v-decorator="['kurir', { rules: [{ required: true }] }]"
          >
            <a-select-option
              v-for="item in getAllKurir"
              :key="item.kurir_id"
              :value="item.kurir_id"
              >{{ item.nama_kurir }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item label="Tracking Number">
          <a-input
            autocomplete="off"
            v-decorator="['no_resi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Delivery Note">
          <a-input
            disabled
            v-decorator="[
              'surat_jalan',
              {
                rules: [{ required: true }],
                initialValue: dataShipmentDeliver.surat_jalan,
              },
            ]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Delivering Date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['tgl_kirim', { rules: [{ required: true }] }]"
          />
        </a-form-item>

        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="3"
            v-decorator="['note', { rules: [{ required: false }] }]"
          />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleShipmentStatusDeliver"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibleShipmentReceive"
      :maskClosable="false"
      :footer="null"
      @cancel="cancelReceive"
      :width="(wideScreen * 90) / 100"
    >
      <span slot="title"> <a-icon type="reload" />&nbsp;Receive </span>
      <!-- <a-card class="m-display-flex flex-column nowrap">
        -- <span slot="title">Receive Item PO</span> --
          <a-steps :current="receiveModal.current" status="process">
            <a-step title="Information" />
            <a-step :title="'Receive Inventory ('+receiveModal.qtyItem+' item)'" />
            <a-step :title="'Receive Aset('+receiveModal.qtyAset+' item)'" />
          </a-steps>
        <div class="steps-content flex-1">
          <keep-alive>
            <component class="flex-1" :is="receiveModal.steps[receiveModal.current].content" :ref="stepRef" v-bind="stepProps"></component>
          </keep-alive>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button v-if="receiveModal.current < receiveModal.steps.length - 1" type="primary" @click="nextStepReceive">Next</a-button>
            <a-button
              :loading="receiveModal.btnLoading"
              v-if="receiveModal.current == receiveModal.steps.length - 1"
              type="primary"
              @click="validateStepReceive"
            >Save</a-button>
            <a-button v-if="receiveModal.current>0" @click="prevStepReceive">Previous</a-button>
          </div>
        </template>
      </a-card> -->
      <a-form :form="formShipmentReceive">
        <a-form-item label="Delivery Note">
          <a-input
            disabled
            v-decorator="[
              'surat_jalan',
              {
                rules: [{ required: true }],
                initialValue: dataShipmentReceive.surat_jalan,
              },
            ]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Receiving Date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['tgl_terima', { rules: [{ required: true }] }]"
          />
        </a-form-item>

        <a-form-item label="Is Aset?" hidden>
          <a-radio-group
            button-style="solid"
            @change="selectIsAssetModal"
            v-model="isAssetModal"
            
          >
            <a-radio-button value="no"> No </a-radio-button>
            <a-radio-button value="yes"> Yes </a-radio-button>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="Used For" :hidden="used_for_status==true">
          <a-radio-group
            button-style="solid"
            @change="selectRadioUsedFor"
            v-model="usedfor"
            :disabled="used_for_status && isAssetModal=='no'"
          >
            <a-radio-button value="unitkelola" v-if="isAssetModal === 'yes'"> Unit Pengelola </a-radio-button>
            <a-radio-button value="gudang" v-if="isAssetModal === 'no'"> Gudang </a-radio-button>
            <a-radio-button value="tlc" :hidden="isAssetModal == 'yes'"> TLC </a-radio-button>
          </a-radio-group>
        </a-form-item>

        <a-form-item v-if="this.usedfor === 'unitkelola'" label="Unit Manage">
          <a-select
            showSearch
            allowClear
            labelInValue
            :filter-option="filterOptionGudang"
            option-filter-prop="children"
            @change="handleSelectedUnitKelola"
            v-decorator="['pengelola_default', { rules: [{ required: false }] }]"
          >
            <a-select-option
              v-for="item in daftarUnitKelola"
              :key="item.aset_unit_id"
              :value="item.aset_unit_id"
              >{{ item.aset_unit_nm }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="this.usedfor === 'gudang'" label="Storage Location">
          <a-select
            showSearch
            allowClear
            labelInValue
            :filter-option="filterOptionGudang"
            option-filter-prop="children"
            @change="handleSelectedStorage"
            v-decorator="['gudang_default', { rules: [{ required: false }] }]"
          >
            <a-select-option
              v-for="item in daftarGudang"
              :key="item.gudang_id"
              :value="item.gudang_id"
              >{{ item.gudang_nm }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="this.usedfor === 'tlc'" label="TLC">
          <a-select
            showSearch
            allowClear
            labelInValue
            :filter-option="filterOptionTlc"
            option-filter-prop="children"
            @change="handleSelectedStoragetlc"
            v-decorator="['tlc_default', { rules: [{ required: false }] }]"
          >
            <a-select-option v-for="user in getAllKaryawan" :key="user.tlc"
              >{{ user.tlc }} - {{ user.nama }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <!--disini po838-->
        <a-table
          :columns="columnsShipmentReceive"
          :dataSource="tempDataReceive"
          size="small"
          :pagination="pagination"
          bordered
        >
          <span slot="item_name" slot-scope="item">
            <h4>{{ item.type_item=="1" ? "[ASET]" : "[ITEM]" }}</h4>
            <h4>{{ item.item_name }}</h4>
            {{ item.item_pn ? "PN : " + item.item_pn : "" }}<br />
            {{ item.kd_anggaran }}<br />
            {{ item.dtl_pp_nm }}
          </span>
          <span slot="item_name_receive" slot-scope="item">
            <h4 class="margin-remove">{{ item.item_name_receive }}</h4>
            <template v-if="item.tlc">
              {{ item.item_name }}
            </template>
            <template v-else>
              {{ item.item_pn_receive ? "PN : " + item.item_pn_receive : "" }}
            </template>
          </span>
          <span slot="price_unit" slot-scope="item">
            {{ formatCurrency('IDR',item.price) }} / {{item.unit ? item.unit : item.satuan}}
          </span>
          <template
            v-for="col in ['quantity', 'gudang_name']"
            :slot="col"
            slot-scope="text"
          >
            <div :key="col">
              <div v-if="col === 'quantity'">
                <template>{{ text.quantity }} {{ text.satuan }} </template>
              </div>

              <div v-else-if="col === 'gudang_name'">
                <template
                  >{{ text.tlc_name ? text.tlc_name : (text.gudang_name ? text.gudang_name : text.unit_kelola_name) }}
                </template>
              </div>
            </div>
          </template>

          <template slot="action" slot-scope="text, record, index">
            <a-button
              @click="handleEditPopover(record)"
              :disabled="!record.gudang_id && !record.tlc && !record.unit_kelola_id"
              type="primary"
              icon="edit"
            >
              Edit
            </a-button>
          </template>
        </a-table>

        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="3"
            v-decorator="['note', { rules: [{ required: false }] }]"
          />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleShipmentStatusReceive"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibleShipmentReceiveManifest"
      width="1000px"
      :footer="null"
      @cancel="cancelReceiveShipmentManifest"
    >
      <span slot="title"> <a-icon type="reload" />&nbsp;Receive Manifest </span>

      <ul class="m-list-wrapper bordered">
        <li>
          <span class="m-list-title" for>Supplier</span>
          <span class="m-list-desc">{{
            dataShipmentManifestHeader.supplier
          }}</span>
        </li>
        <li>
          <span class="m-list-title" for>Receive Date</span>
          <span class="m-list-desc">{{
            moment(
              dataShipmentManifestHeader.receive_dt,
              getStandartFormatDate
            ).format(getDefaultDateFormat)
          }}</span>
        </li>
        <li>
          <span class="m-list-title" for>Delivery Note</span>
          <span class="m-list-desc">{{
            dataShipmentManifestHeader.delivery_note
          }}</span>
        </li>
      </ul>

      <a-table
        :columns="columnsShipmentManifestReceive"
        size="small"
        :dataSource="dataShipmentManifestDetail"
        :pagination="pagination"
        bordered
      >
        <span slot="previous_item" slot-scope="i, item">
          <b>[{{item.type_item}}]</b>
          <br />
          {{ item.nama_barang_po_dtl }}
          <br />
          PN : {{ item.pn_barang_po_dtl !== "" ? item.pn_barang_po_dtl : "-" }}
        </span>
        <span slot="nama_barang" slot-scope="i, item">
          {{ item.nama_barang }}
          <br />
          PN : {{ item.pn_barang !== "" ? item.pn_barang : "-" }}
          <br />
        </span>
      </a-table>
    </a-modal>

    <a-modal
      v-model="visibleCloseForm"
      width="50%"
    >
      <span slot="title">
        Close Transaction
      </span>

      <a-table
        key="Idrefund1"
        rowKey="Idrefund1"
        :columns="columnsclosepo"
        :dataSource="tableClosepo.data"
        :pagination="false"
        size="small"
        :loading="loadtableclose"
        bordered
        :scroll="{ y: 400, x: 400 }"
      >
        <span slot="pp_dtl" slot-scope="pp_dtl">
          <b>{{ pp_dtl.nama_barang }}</b
          ><br/>
          {{ pp_dtl.kode_anggaran }}
        </span>
        <template  slot="ppdtl_val" slot-scope="text, record, index">
          <a-input
            style="margin: -5px 0"
            class="m-width-full m-text-align right"
            :min="0.0"
            :value="text"
            @keydown="onlyNumber"
            @change="e => handleChangeClosepo(e.target.value, record.id_pp_dtl, 'value')"
          />
        </template>
        <div slot="footer" class="padding-all">
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              >Total</a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                :currencyValue="tableClosepo.currency"
                :valueNumber="tempvalClosepo"
              />
            </a-col>
          </a-row>

          <a-divider class="margin-small" />
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              >Total Refund</a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="tableClosepo.sisa_transfer"
                :currencyValue="tableClosepo.currency"
                :valueNumber="tableClosepo.sisa_transfer"
              />
            </a-col>
          </a-row>
        </div>
      </a-table>
      <template slot="footer">
        <a-button key="submit" :disabled="disabledClosetranspo" type="primary" @click="saveCloseForm">
          Save
        </a-button>
      </template>
    </a-modal>

    <a-modal
      v-model="visibleCloseFormview"
      :footer="null"
      :width="!getScreen ? '50%' : '80%'"
    >
      <span slot="title">
        Refund Transaction
      </span>

      <a-table
        key="refund2"
        rowKey="refund2"
        :columns="columnsclosepoview"
        :dataSource="data.refund"
        :pagination="false"
        size="small"
        :loading="loadtableclose"
        bordered
        :scroll="{ y: 400, x: 400 }"
      >
        <span slot="pp_dtl" slot-scope="pp_dtl">
          <b>{{ pp_dtl.nama_barang }}</b
          ><br/>
          {{ pp_dtl.kode_anggaran }}
        </span>
        <template  slot="ppdtl_val" slot-scope="record">
          <CurrencyJustified
                :currencyValue="currency"
                :valueNumber="record.refund"
              />
        </template>
        <div slot="footer" class="padding-all">
          <a-row type="flex">
            <a-col :span="!getScreen ? 5 : 8" :order="1" class="m-text-align left"
              >Total Refund</a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                :currencyValue="currency"
                :valueNumber="data.total.refundTotal"
              />
            </a-col>
          </a-row>
        </div>
      </a-table>
    </a-modal>

    <a-modal
      v-model="modalhistPaymentrefund"
      :footer="null"
      :width="'80%'"
    >
      <span slot="title">
        History Before Payment Refund
      </span>
      <a-input-search
        v-model="histpaymentRefundsearch"
        placeholder="Quick Search"
        allowClear
        class="margin-bottom"
      />
      <a-table
        :rowKey="(record, index) => {return index;}"
        :columns="columnshistrefundpayment"
        :dataSource="histpaymentData"
        :pagination="pagination"
        size="small"
        bordered
        :scroll="{ x: 950 }"
      >
        <span slot="no" slot-scope="text,record,index">
          {{index+1}}
        </span>
        <span slot="item_PN" slot-scope="item_PN">
          <b>{{ item_PN.nama_barang }}</b
          ><br />
          {{
            item_PN.item_pn || item_PN.item_pn !== ""
              ? "PN : " +
                (item_PN.item_pn == null ? "-" : item_PN.item_pn)
              : ""
          }}<br />{{ "( "+item_PN.type_item +" )"}}<br />
        </span>
        <span slot="ppdtl" slot-scope="ppdtl">
          {{ ppdtl.nama_barang_pp }}<br />
          <i> {{ ppdtl.kode_anggaran }}</i>
        </span>
        <span slot="inventory" slot-scope="item">
          {{ item.isinventaris=='1' ? "Yes" : "No" }}
        </span>
        <span slot="quantity" slot-scope="text,record">
          {{record.jumlah}} {{record.satuan}}
        </span>
        <span slot="unit_price" slot-scope="unit_price">
          <CurrencyJustified
            :currencyValue="currency"
            :valueNumber="unit_price.harga === 0 ? 0.0 : unit_price.harga"
          />
        </span>
        <span slot="amount" slot-scope="amount">
          <CurrencyJustified
            :currencyValue="currency"
            :valueNumber="amount.jumlah*amount.harga"
          />
        </span>
        <div slot="footer" class="padding-all">
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              ><b>Total</b></a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="data.total.totalitem_historypaymentrefund"
                :currencyValue="currency"
                :valueNumber="data.total.totalitem_historypaymentrefund"
              />
            </a-col>
          </a-row>

          <a-row
            type="flex"
            v-for="(item, index) in histpaymentDataother"
            :key="index"
          >
            <a-col :span="5" :order="1" class="m-text-align left">
              {{ item.nama_barang }}
              {{ item.persen !== null ? "(" + item.persen + "%)" : "" }}
            </a-col>
            <a-col
              :span="1"
              :order="2"
              class="m-text-align right m-text-bold"
            >
              <!-- {{ item.kategori == "1" || (item.kategori == "2" && item.tax_bearer=="1") ? "-" : "" }} -->
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="item.total_harga"
                :currencyValue="currency"
                :valueNumber="item.total_harga"
              />
            </a-col>
          </a-row>

          <a-divider class="margin-small" />
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              ><b>Total Bill</b></a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="data.total.grandTotal_historypaymentrefund"
                :currencyValue="currency"
                :valueNumber="data.total.grandTotal_historypaymentrefund"
              />
            </a-col>
          </a-row>
        </div>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";
import GlobalMethod from "@/mixins/GlobalMethod.js";

import InformasiReceive from "./stepsPoReceiveItem/Informasi.vue";
import ReceiveItem from "./stepsPoReceiveItem/ReceiveItemAset.vue";
import ReceiveAset from "./stepsPoReceiveItem/ReceiveItemAset.vue";

export default {
  name: "PoManifest",
  components: {
    ACol,
    Status,
    InformasiReceive,
    ReceiveItem,
    ReceiveAset
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      wideScreen: window.innerWidth,
      previewVisible: false,
      previewImage: "",
      loading: true,
      visibleHistory: false,
      visibleLampiran: false,
      visiblePop: false,
      visibleShipmentStatus: false,
      visibleShipmentDeliver: false,
      visibleShipmentReceive: false,
      visibleShipmentReceiveManifest: false,
      visibleDpo: false,
      visibleCloseForm: false,
      visiblemenupopover: false,
      modalListDpo: [],
      fileListLampiran: [],
      fileListModalLampiran: [],
      fileList: [],
      fileListModal: [],
      reqFileTf: true,
      disableNilaiTf: true,
      data: {
        detail_pembelian: [],
        detail_history: [],
        dokumen_terkait: [],
        detailBuktiTransfer: [],
        manifest: {},
        status: [],
        history: [],
        total: {
          subTotal: "",
          grandTotal: "",
          nilaiPajak: "",
          refundTotal:0,
        },
        dokumen_butuh: [],
        lampiran: [],
        jenis: "",
        aksi: [],
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      pajak: "",
      dateFormat: "DD MMMM YYYY",
      tlc: "",
      cek_value: 1,
      sisa_tf: "",
      temp_sisa_tf: "",
      temp_gudang_id: "",
      penerimaan: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 19 },
        },
      },
      currency: "",
      printLoad: {
        manifest: false,
        cancel: false,
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      status_shipment: [],
      dataShipmentDeliver: [],
      dataShipmentReceive: [],
      dataShipmentManifestDetail: [],
      dataShipmentManifestHeader: [],
      tempDataReceive: [],
      clickedPop: false,
      cacheData: {},
      btnShipment: {},
      dataDetailShipment: {},
      daftarGudang: {},
      daftarUnitKelola: {},
      checkTransferValue: true,
      allowEditModal: false,
      editGudangVal: undefined,
      usedfor: "gudang",
      editTlcVal: undefined,
      visibleEditDtl: false,
      enabledEditDtl: false,
      editReceiveDtl: {
        title: "",
        key: "",
        qty: 0,
        tlc: "",
        tlc_name: "",
        opsi: "gudangreceive",
        idgudang: "",
        gudang_name: "",
        itempnConcat: "",
      },
      dtabel: [],
      dtemptabel: [],
      dlist: [],
      dataPNitem: [],
      dataPNAset: [],
      selectedPN: null,
      selectedPNAset: null,
      used_for_status: false,
      loadtableclose: false,
      tableClosepo: [],
      disabledClosetranspo: true,
      displaylistrefund: false,
      visibleCloseFormview: false,
      isAssetModal: "no",
      receiveModal: {
        current: 0,
        steps: [
          {
            title: "Informasi",
            content: "InformasiReceive"
          },
          {
            title: "Receive Item",
            content: "ReceiveItem"
          },
          {
            title: "Receive Aset",
            content: "ReceiveAset",
          },
        ],
        btnLoading: false,
        qtyAset:0,
        qtyItem:0,
      },
      visiblehistorypaymentrefund:false,
      modalhistPaymentrefund:false,
      histpaymentRefundsearch:undefined,
      histpaymentData: [],
      histpaymentDatatemp:[],
      histpaymentDataother: [],
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KURIR");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    this.getPNitem(null);
    this.getPNAset();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formLampiran = this.$form.createForm(this);
    this.formShipmentStatus = this.$form.createForm(this);
    this.formShipmentDeliver = this.$form.createForm(this);
    this.formDpo = this.$form.createForm(this);
    this.formShipmentReceive = this.$form.createForm(this);
    this.formSetReceive = this.$form.createForm(this);
    this.formeditRowDtl = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getAllGudang",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStatusShipment",
      "getAllKurir",
      "getAllKaryawan",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 70,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item_PN" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detil",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Is Inventory",
          width: 120,
          key: "inventory",
          align: " center",
          scopedSlots: { customRender: "inventory" },
          sorter: (a, b) => a.isinventaris.length - b.isinventaris.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          scopedSlots: { customRender: "unit_price" },
          width: 100,
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          scopedSlots: { customRender: "amount" },
          width: 100,
        },
        {
          title: "Note",
          dataIndex: "catatan_dtl",
          key: "catatan_dtl",
          width: 150,
        },
      ];
      return kolom;
    },
    columnshistrefundpayment() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no" },
          width: 50,
        },
        {
          title: "Item Name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item_PN" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detil",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          key: "quantity",
          width: 100,
          scopedSlots: { customRender: "quantity" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          key: "unit_price",
          scopedSlots: { customRender: "unit_price" },
          width: 100,
        },
        {
          title: "Amount",
          key: "amount",
          scopedSlots: { customRender: "amount" },
          width: 100,
        },
      ];
      return kolom;
    },
    columnsShipmentReceive() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: "8%",
        },
        {
          title: "Item Name",
          width: "28%",
          key: "item_name",
          scopedSlots: { customRender: "item_name" },
        },
        {
          title: "Item Receive",
          width: "28%",
          key: "item_name_receive",
          scopedSlots: { customRender: "item_name_receive" },
        },
        {
          title: "Qty",
          key: "quantity",
          width: "9%",
          scopedSlots: { customRender: "quantity" },
        },
        {
          title: "Unit Price",
          key: "price_unit",
          width: "15%",
          align: "right",
          scopedSlots: { customRender: "price_unit" },
        },
        {
          title: "Storage Location / TLC",
          key: "gudang_name",
          scopedSlots: { customRender: "gudang_name" },
          width: "45%",
        },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          scopedSlots: { customRender: "action" },
          width: "10%",
        },
      ];
      return kolom;
    },
    columnsShipmentManifestReceive() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 50,
        },
        {
          title: "Previous Item",
          dataIndex: "nama_barang_po_dtl",
          key: "nama_barang_po_dtl",
          width: 200,
          scopedSlots: { customRender: "previous_item" },
        },
        {
          title: "Item Name",
          dataIndex: "nama_barang",
          width: 200,
          key: "nama_barang",
          scopedSlots: { customRender: "nama_barang" },
        },
        {
          title: "Po Qty",
          dataIndex: "po_qty",
          key: "po_qty",
          width: 100,
        },
        {
          title: "Receive Qty",
          dataIndex: "recieve_qty",
          key: "recieve_qty",
          width: 100,
        },
        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 100,
          align: "right",
        },
        {
          title: "Storage Location / TLC",
          dataIndex: "gudang_nm",
          key: "gudang_nm",
          width: 200,
        },
      ];
      return kolom;
    },

    columnsclosepo() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "PP Detil",
          width: 150,
          key: "pp_dtl",
          scopedSlots: { customRender: "pp_dtl" },
          sorter: (a, b) => a.nama_barang.length - b.nama_barang.length,
        },
        {
          title: "Value",
          width: 50,
          dataIndex: "value",
          key: "ppdtl_val",
          scopedSlots: { customRender: "ppdtl_val" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
      ];
      return kolom;
    },

    columnsclosepoview() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "PP Detil",
          width: 150,
          key: "pp_dtl",
          scopedSlots: { customRender: "pp_dtl" },
          sorter: (a, b) => a.nama_barang.length - b.nama_barang.length,
        },
        {
          title: "Value",
          width: 50,
          key: "pp_dtl_val",
          scopedSlots: { customRender: "ppdtl_val" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
      ];
      return kolom;
    },

    searching() {
      if (this.search) {
        this.tableData = this.tableData.filter(
          (obj) =>
            obj.item_name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
    getLastStatusShipment() {
      if (this.status_shipment) {
        if (this.status_shipment.length !== 0) {
          if (
            this.status_shipment[this.status_shipment.length - 1].deli_sts ===
            "Received"
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getMainStatus() {
      if (this.data.status.length !== 0) {
        return this.data.status[this.data.status.length - 1].status;
      }
    },
    getShippingflag() {
      return this.data.shipping_flag;
    },
    tempvalClosepo(){
      let rest = 0;
      if(this.tableClosepo.data){
        for (let index = 0; index < this.tableClosepo.data.length; index++) {
          rest = rest + Number(this.tableClosepo.data[index].value);
        }
      }
      return rest;
    },
    stepProps: function() {
      if (this.receiveModal.steps[this.receiveModal.current].content === "InformasiReceive") {
        return {
          data: this.dataShipmentReceive,
        };
      } else if (this.receiveModal.steps[this.receiveModal.current].content === "ReceiveItem") {
        return {
          isAssetModalParent: this.isAssetModal,
          formShipmentReceiveParent: this.formShipmentReceive,
          tempDataReceiveParent: this.tempDataReceive,
          used_for_status: this.used_for_status,
          usedforParent: this.usedfor,
          daftarUnitKelola: this.daftarUnitKelola,
          daftarGudang: this.daftarGudang,
          AllKaryawan: this.getAllKaryawan,
          columnsShipmentReceive: this.columnsShipmentReceive,
          pagination: this.pagination,
        };
      } else {
        return {
          isAssetModalParent: this.isAssetModal,
          formShipmentReceiveParent: this.formShipmentReceive,
          tempDataReceiveParent: this.tempDataReceive,
          used_for_status: this.used_for_status,
          usedforParent: this.usedfor,
          daftarUnitKelola: this.daftarUnitKelola,
          daftarGudang: this.daftarGudang,
          AllKaryawan: this.getAllKaryawan,
          columnsShipmentReceive: this.columnsShipmentReceive,
          pagination: this.pagination,
        };
      }
    },
    stepRef: function() {
      //console.log(this.steps[this.current].content)
      if (this.receiveModal.steps[this.receiveModal.current].content === "InformasiReceive") {
        return "refInformasi";
      } else if (this.receiveModal.steps[this.receiveModal.current].content === "ReceiveItem") {
        return "refItem";
      }else{
        return "refAset";
      }
    },
    anyPPH() {
      let r = _.filter(this.dlist, (item) => item.tax_type && item.tax_type.indexOf("pph") >= 0);
      return r.length > 0
    }
  },
  methods: {
    ...mapActions(["FETCH_ALL_KURIR"]),
    moment,
    handleEditPopover(val) {
      this.visibleEditDtl = true;
      this.formeditRowDtl = this.$form.createForm(this);

      let tempgdg = null;
      let temptlc = null;
      let tempunitkelola = null;

      if(val.unit_kelola_id){
        tempunitkelola = _.filter(
          this.daftarUnitKelola,
          (nav) => nav.aset_unit_id.indexOf(val.unit_kelola_id) >= 0
        );
      } else if (val.gudang_id) {
        tempgdg = _.filter(
          this.daftarGudang,
          (nav) => nav.gudang_id.indexOf(val.gudang_id) >= 0
        );
      } else if(val.tlc_name){
        temptlc = _.filter(
          this.getAllKaryawan,
          (nav) => nav.tlc.indexOf(val.tlc) >= 0
        );
      }
      
      this.editReceiveDtl = {
        title: val.item_name,
        key: val.key,
        qty: val.quantity,
        tlc: val.tlc,
        opsi: (tempgdg ? val.gudang_id : null) ? "gudangreceive" : (val.tlc ? "tlcreceive" : "unitkelola"),
        idgudang: tempgdg ? val.gudang_id : null,
        gudang_name: tempgdg ? (tempgdg.length>0 ? tempgdg[0].gudang_nm : "") : "",
        tlc_name: temptlc ? (temptlc.length ? temptlc[0].nama : "" ) : "",
        item_pn: (val.item_pn_receive!=null ? val.item_pn_receive : val.item_pn),
        id_po_dtl: val.id_po_dtl,
        unit_po_receive: val.unit_receive,
        unit_receive: val.satuan,
        price_receive: val.price,
        type_item: val.type_item,
        unit_kelola_id: (tempunitkelola ? (tempunitkelola.length>0 ? tempunitkelola[0].aset_unit_id : "" ) : ""),
        unit_kelola_name: (tempunitkelola ? (tempunitkelola.length>0 ? tempunitkelola[0].aset_unit_nm : "") : ""),
      };
      if(val.type_item=='1'){
        let a = [
          {
            aset_pn: val.item_pn_receive!=null ? val.item_pn_receive : val.item_pn,
            aset_nm: val.item_name_receive!=null
              ? val.item_name_receive
              : val.item_name,
            item_pn_concat: val.item_pn_receive!=null
              ? val.item_name_receive.concat(" ( ", val.item_pn_receive, " ) ")
              : val.item_name,
            satuan: val.item_pn_receive!=null
              ? val.unit : val.satuan,
          },
        ];
        this.selectedPNAset = a[0];
      }else{
        let a = [
          {
            item_pn: val.item_pn_receive!=null ? val.item_pn_receive : val.item_pn,
            item_nm: val.item_name_receive!=null
              ? val.item_name_receive
              : val.item_name,
            item_pn_concat: val.item_pn_receive!=null
              ? val.item_name_receive.concat(" ( ", val.item_pn_receive, " ) ")
              : val.item_name.concat(" ( ", val.item_pn, " ) "),
            satuan: val.item_pn_receive!=null
              ? val.unit : val.satuan,
          },
        ];

        let isexistonlist = _.filter(this.dataPNitem,(el) =>
            el.item_pn == a[0].item_pn);
        
        if(isexistonlist.length>0){
          this.selectedPN = a[0];
        }else{
          this.selectedPN = null;
        }
      }
    },
    fetchManifest() {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "po",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let ttlrefund = 0;
          if (response.data.refund){
            this.displaylistrefund = true;
            for (let index = 0; index < response.data.refund.length; index++) {
              ttlrefund = ttlrefund + Number(response.data.refund[index].refund);
            }
          }

          this.data = {
            print_btn: response.data.print_btn,
            catatan: response.data.header.catatan=="" ? '-' : 
              response.data.header.catatan,
            ap: response.data.ap,
            currency: response.data.currency,
            manifest: response.data.header,
            detail_pembelian: response.data.detail,
            detail_history: response.data.detail_history,
            total: {
              subTotal: response.data.subtotal,
              grandTotal: response.data.granTotal,
              nilaiPajak:
                (parseFloat(response.data.pajak) / 100.0) *
                response.data.subtotal,
              shipping: response.data.shipping,
              totalitem: response.data.totalitem,
              refundTotal: ttlrefund,
            },
            dokumen_butuh: response.data.document,
            status: response.data.status_app,
            history: response.data.notifikasi,
            dokumen_terkait: response.data.dokumen_terkait,
            lampiran: response.data.lampiran,
            jenis: response.data.jenis,
            status_transfer: response.data.status_transfer,
            aksi: response.data.aksi,
            detailBuktiTransfer: response.data.buktiTransfer,
            purchasing: response.data.purchasing,
            last_status: response.data.last_status,
            shipping_flag: response.data.shipping_flag,
            revised_flag:
              response.data.header.revised_flag == "1" ? true : false,
            cancel_sts: response.data.header.cancel_sts == "2" ? true : false,
            close_btn: response.data.close_btn,
            cancel_btn: response.data.cancel_btn,
            refund: response.data.refund,
          };
          this.pajak = response.data.pajak;
          this.tlc = this.getAuth.username;
          this.sisa_tf = response.data.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;
          this.penerimaan = response.data.penerimaan;
          this.currency = response.data.currency;
          this.visiblehistorypaymentrefund = response.data.history;

          let dbt = this.data.detailBuktiTransfer;
          for (const [i, val] of dbt.entries()) {
            let name = i + 1 + val.url.substring(val.url.lastIndexOf("."));
            this.data.detailBuktiTransfer[i]["fileList"] = [
              {
                url: process.env.VUE_APP_SERVICEURL + val.url,
                uid: i,
                name: name,
                status: "done",
              },
            ];
            // this.data.tgl_bukti_transfer.push(moment(val.tgl_tf).format(this.data.dateFormatTf));
          }

          this.dtabel = [];
          this.dtemptabel = [];
          this.dlist = [];
          let tempdtl = response.data.detail;
          for (let index = 0; index < tempdtl.length; index++) {
            const element = tempdtl[index];
            if (tempdtl[index].kategori == "0") {
              this.dtabel.push(element);
              this.dtemptabel.push(element);
            } else {
              this.dlist.push(element);
            }
          }

          if (!this.getScreen) {
            let dataPemakaian = this.dtemptabel;
            this.dtemptabel.forEach((value, index) => {
              dataPemakaian[index]["no"] = index + 1;
              dataPemakaian[index]["key"] = index;
              dataPemakaian[index]["item_name"] = value.nama_barang;
              dataPemakaian[index]["item_pn"] = value.item_pn;
              dataPemakaian[index]["quantity"] =
                value.jumlah + " " + value.satuan;
              dataPemakaian[index]["unit_price"] = {
                curr: response.data.currency,
                val: Number(value.harga) === 0 ? 0.0 : Number(value.harga),
              };
              dataPemakaian[index]["amount"] = {
                curr: response.data.currency,
                val: Number(value.total_harga),
              };
            });

            this.tableData = dataPemakaian;
            this.tableDataTemp = dataPemakaian;
          }

          this.isAssetModal = response.data.header.jns_anggaran=="05" ? "yes" : "no";

          this.usedfor = this.isAssetModal == 'yes' ? 'unitkelola' : 'gudang';

          this.histpaymentData = [];
          this.histpaymentDatatemp = [];
          this.histpaymentDataother = [];
          let tempdtl2 = response.data.detail_history;
          let totalhistpaymentother = 0;
          for (let index = 0; index < tempdtl2.length; index++) {
            const element = tempdtl2[index];
            if (tempdtl2[index].kategori == "0") {
              this.histpaymentData.push(element);
              this.histpaymentDatatemp.push(element);
            } else {
              this.histpaymentDataother.push(element);
              totalhistpaymentother += (element.jumlah * element.harga);
            }
          }

          this.data.total.totalitem_historypaymentrefund = response.data.total_item_history;
          this.data.total.grandTotal_historypaymentrefund = 
            Number(this.data.total.totalitem_historypaymentrefund) + totalhistpaymentother;

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAction() {
      if (this.data.jenis === "Transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }
          let formData = new FormData();

          if (values.status === "Revised") {
            formData.append("tlc", this.getAuth.username);
            formData.append("id_manifest", this.id);
            formData.append("remark", values.catatan ? values.catatan : "");
            formData.append("status", values.status);
            formData.append("cek_value", this.cek_value);
            formData.append("value_transfer", values.value_transferan);
            formData.append(
              "tgl_transfer",
              moment(values.tgl_tf).format(this.getStandartFormatDate)
            );
          } else if (values.status === "Transferred") {
            formData.append("tlc", this.getAuth.username);
            formData.append("id_manifest", this.id);
            formData.append("remark", values.catatan ? values.catatan : "");
            formData.append("status", values.status);
            formData.append("cek_value", this.cek_value);
            formData.append("value_transfer", values.value_transferan);
            formData.append("file_transfer", values.file_transfer.file);
            formData.append(
              "tgl_transfer",
              moment(values.tgl_tf).format(this.getStandartFormatDate)
            );
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "po/approval",

            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "po/approval",
            processData: false,
            data: {
              id_manifest: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              /* this.$router.push({ name: "po" }); */
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    addShipmentStatus(e) {
      e.stopPropagation();
      this.visibleShipmentStatus = !this.visibleShipmentStatus;
    },
    addShipmentDeliver(val) {
      this.dataShipmentDeliver = val;
      this.visibleShipmentDeliver = !this.visibleShipmentDeliver;
    },

    addShipmentReceive(val, dataShipment) {
      this.dataShipmentReceive = val;
      this.visibleShipmentReceive = !this.visibleShipmentReceive;
      this.cacheData = this.tempDataReceive;

      this.getDataReceivePost(dataShipment);

      let qtyitem = _.filter(
          this.tempDataReceive,
          (el) => el.type_item!="1"
        );
      this.receiveModal.qtyItem = qtyitem.length;
      let qtyaset = _.filter(
          this.tempDataReceive,
          (el) => el.type_item=="1"
        );
      this.receiveModal.qtyAset = qtyaset.length;
      //disini 2
    },
    cancelShipmentStatus() {
      // this.fileListLampiran = [];
      // this.formLampiran.resetFields();
      this.formShipmentStatus.resetFields();
    },
    cancelDeliver() {
      // this.fileListLampiran = [];
      // this.formLampiran.resetFields();
      this.dataShipmentDeliver = [];
      this.formShipmentDeliver.resetFields();
    },
    cancelReceive() {
      this.dataShipmentReceive = [];
      this.formShipmentReceive.resetFields();
      // this.tempDataReceive = this.cacheData;
      this.tempDataReceive = [];
      this.editReceiveDtl = {};
      this.enabledEditDtl = false;
      // this.visibleShipmentReceive = !this.visibleShipmentReceive;
    },
    cancelLampiran() {
      this.fileListModalLampiran = [];
      this.formLampiran.resetFields();
      //console.log(this.formLampiran.getFieldsValue());
      this.formLampiran.setFieldsValue({
        file_list_lampiran: ""
      })
    },
    showManifestShipment(header, val) {
      let detail = val.map((item, index) => {
        return {
          no: index + 1,
          key: index,
          nama_barang: item.nama_barang,
          po_qty: item.po_qty + " " + item.satuan,
          recieve_qty: item.recieve_qty + " " + item.satuan_master,
          gudang_nm: item.gudang_nm,
          nama_barang_po_dtl: item.nama_barang_po_dtl,
          pn_barang_po_dtl: item.pn_barang_po_dtl,
          pn_barang: item.pn_barang,
          unit_price: this.formatCurrency('IDR', item.harga),
          type_item: item.type_item ? item.type_item.toUpperCase() : null,
        };
      });
      // val.forEach((item,index)=>{
      //     detail[index].no = index+1;
      //     detail[index].key= index;
      //     detail[index].po_qty= detail[index].po_qty +' '+ detail[index].satuan ;
      //     detail[index].recieve_qty= detail[index].recieve_qty +' '+ detail[index].satuan ;
      // })

      // console.log(val);

      this.dataShipmentManifestHeader = header;
      this.dataShipmentManifestDetail = detail;
      this.visibleShipmentReceiveManifest =
        !this.visibleShipmentReceiveManifest;
    },
    cancelReceiveShipmentManifest() {
      this.dataShipmentManifestHeader = [];
      this.dataShipmentManifestDetail = [];
      this.visibleShipmentReceiveManifest =
        !this.visibleShipmentReceiveManifest;
    },

    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (values.file_list_lampiran.fileList.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        Axios({
          method: "post",
          url: this.$serviceUrl + "po/upload_lampiran",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go(0);
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    beforeUploadModal(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileListModal.push(file);
        } else {
          this.fileListModalLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    handleRemoveModal(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileListModal.indexOf(file);
        const newFileList = this.fileListModal.slice();
        newFileList.splice(index, 1);
        this.fileListModal = newFileList;
      } else {
        const index = this.fileListModalLampiran.indexOf(file);
        const newFileList = this.fileListModalLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListModalLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    onChangeStatus(val) {
      if (val === "Revised") {
        this.reqFileTf = false;
        this.fileList = [];
        this.$nextTick(() => {
          this.form.validateFields(["file_transfer"], { force: true });
        });
      } else if (val === "Transferred") {
        this.reqFileTf = true;
        /*this.$nextTick(() => {
          this.form.validateFields(["file_transfer"], { force: true });
        }); */
      }
    },
    onClickItem(item) {
      if (
        this.penerimaan.length > 0 &&
        this.data.jenis === "Manifest" &&
        this.data.manifest.prepared_by === this.getAuth.username
      ) {
        this.visibleDpo = !this.visibleDpo;
        this.modalListDpo = item;

        if (item.tgl_terima != null) {
          this.modalListDpo.tgl_terima = moment(
            item.tgl_terima,
            this.dateFormat
          );
          this.temp_gudang_id = item.id_gudang;
        }
      }
    },
    cancelModalDpo() {
      this.formDpo.resetFields();
      this.visibleDpo = !this.visibleDpo;
    },
    handleGudangLokasi(value) {
      this.temp_gudang_id = value;
    },
    handlePenerimaan() {
      this.formDpo.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_po", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("id_dtl", this.modalListDpo.id_dtl);
        formData.append("id_gudang", this.temp_gudang_id);
        formData.append("jumlah_isi", values.jumlah);
        formData.append(
          "tgl_terima",
          moment(values.tgl_terima).format(this.getStandartFormatDate)
        );
        Axios({
          method: "post",
          url: this.$serviceUrl + "po/penerimaan",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleDpo = !this.visibleDpo;
            //this.$router.go(0);
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handlePreview(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(file.url, "_blank");
      } else {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "po/cetak_laporan_po",
        responseType: "blob",
        params: {
          id_po: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          this.printLoad.manifest = false;
          let responses = Object.assign({}, err.response.data);
          console.log(responses)
          if (responses.message && responses.status==false){
            this.displayMessageValue("error-other", responses.message);
          }else{
            this.displayMessageValue("error", responses);
          }
        });
    },
    handleDokumenButuh() {
      let countChar = "";
      let vretur = true;
      this.data.dokumen_butuh.forEach((item) => {
        if (item !== "") {
          countChar = countChar + item;
        }
      });
      if (countChar.length > 0) {
        vretur = false;
      }
      return vretur;
    },
    handleDownload(item) {
      if (item.source === "simfoni") {
        window.open(this.$serviceUrl + item.url, "_blank");
      } else {
        window.open(item.url, "_blank");
      }
    },
    handleShipmentStatusDialog() {
      this.formShipmentStatus.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        } else {
          // this.confirmMessage("confirm-save");
          this.confirmMessageValue("confirm-add-detil", values);
        }
      });
    },
    handleShipmentStatusDeliver() {
      this.formShipmentDeliver.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        } else {
          // this.confirmMessage("confirm-save");
          this.confirmMessageValue("confirm-add-detil", values);
        }
      });
    },

    handleShipmentStatusReceive() {
      const edit = this.tempDataReceive.filter((item, index) => {
        return item.edit === true;
      });

      this.formShipmentReceive.validateFields((err, values) => {
        if (err) {
          edit.forEach((item) => {
            const decorator = item.key;
            this.formShipmentReceive.setFields({
              [decorator]: { errors: [new Error("Not save yet")] },
            });
          });
          this.displayMessage("form-warning");
          return;
        } else {
          
          const checkData = this.tempDataReceive.filter((item) => {
            return item.tlc == undefined && (item.type_item!='1' && item.item_pn_receive === null) && item.quantity !== 0;
          });

          const checkQty = this.tempDataReceive.filter((item) => {
            return item.quantity === 0;
          });

          if (edit.length > 0) {
            edit.forEach((item) => {
              const decorator = item.key;
              this.formShipmentReceive.setFields({
                [decorator]: { errors: [new Error("Not yet save")] },
              });
            });
          } else if (checkData.length > 0) {
            this.displayMessageCustom(
              "warning-form-message",
              "Please click Edit button to edit column Item Receive"
            );
          } else if (checkQty.length == this.tempDataReceive.length) {
            this.displayMessageCustom(
              "warning-form-message",
              "Please set quantity item receive"
            );
          } else {
            this.confirmMessageValue(
              "confirm-add-detil-po",
              values,
              this.tempDataReceive
            );
          }
        }
      });
    },

    handleShipmentStatus(values) {
      let formData = new FormData();
      //
      formData.append("id_po", this.id);
      formData.append("tlc", this.getAuth.username);
      formData.append("shipment_status", "Delivered");
      formData.append("kurir", values.kurir);
      formData.append(
        "tgl_kirim",
        moment(values.tgl_kirim, this.getDefaultDateFormat).format(
          this.getStandartFormatDate
        )
      );
      formData.append("surat_jalan", values.delivery_note);
      formData.append("no_resi", values.no_resi);

      if (this.visibleShipmentStatus) {
        formData.append("po_deli_id", "");
      }

      if (this.visibleShipmentDeliver) {
        formData.append("po_deli_id", this.dataShipmentDeliver.po_deli_id);
      }

      if (values.note) {
        formData.append("note", values.note);
      } else {
        formData.append("note", "");
      }

      Axios({
        method: "post",
        url: this.$serviceUrl + "po/penerimaan",
        processData: false,
        data: formData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.visibleShipmentStatus = false;
          this.displayMessage("success-send");
          this.$router.go(0);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    filterGudang(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    fetchShipment() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "po/shipment_status",
        params: {
          id_po: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.status_shipment = response.data.shipment_status;
          this.btnShipment = response.data.button_plus;
          this.dataDetailShipment = response.data.belum_diterima;
          this.daftarGudang = response.data.daftar_gudang;
          this.daftarUnitKelola = response.data.daftar_unit_kelola;
          this.used_for_status =
            response.data.used_for == "disabled" ? true : false;
        })
        .catch((error) => {
          // console.log("error : " + error);
        });
    },

    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },
    handleRemoveLampiran(item) {
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      Axios({
        method: "delete",
        url: serviceUrl + "po/lampiran",
        processData: false,
        data: {
          id_po_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          Event.$emit("refresh", true);
          if (response.data.message === "Delete Success") {
            this.displayMessage("success-del");
          } else {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error", responses);
          }
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },

    // metede template dari vue antd
    edit(key) {
      this.cacheData = this.tempDataReceive.map((item) => ({ ...item }));
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      this.editGudangVal = target.gudang_id;
      this.editTlcVal = target.tlc;
      this.editUnitKelolaVal = target.unit_kelola_id;

      if (target) {
        target.edit = true;
        target.editable = true;
        this.tempDataReceive = newData;
        // this.fullName = newData;
      }
    },
    handleChange(value, key, column) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.tempDataReceive = newData;
      }
    },
    handleSelected(value, key, column, index) {
      if (value === undefined) {
        const newData = [...this.tempDataReceive];
        const target = newData.filter((item) => key === item.key)[0];
        if (target) {
          // target[column] = dataFilter[0].gudang_nm;
          target["gudang_id"] = null;
          target["gudang_name"] = null;
          target["tlc"] = null;
          target["tlc_name"] = null;
          target["unit_kelola_id"] = null;
          target["unit_kelola_name"] = null;
          this.tempDataReceive = newData;
        }
      } else {
        if (this.usedfor === "gudang") {
          let dataFilter = this.getAllGudang.filter(
            (obj) =>
              obj.gudang_id.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );

          const newData = [...this.tempDataReceive];
          const target = newData.filter((item) => key === item.key)[0];
          if (target) {
            target[column] = dataFilter[0].gudang_nm;
            target["gudang_id"] = value;
            this.tempDataReceive = newData;
          }
        } else if(this.usedfor === "unit_kelola") {
          let dataFilter = this.daftarUnitKelola.filter(
            (obj) => obj.aset_unit_id.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );

          const newData = [...this.tempDataReceive];
          const target = newData.filter((item) => key === item.key)[0];
          if (target) {
            target[column] = dataFilter[0].unit_kelola_nm;
            target["unit_kelola_id"] = value;
            this.tempDataReceive = newData;
          }
        }else {
          let dataFilter = this.getAllKaryawan.filter(
            (obj) => obj.tlc.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );

          const newData = [...this.tempDataReceive];
          const target = newData.filter((item) => key === item.key)[0];
          if (target) {
            target[column] = dataFilter[0].tlc_nm;
            target["tlc"] = value;
            this.tempDataReceive = newData;
          }
        }
      }
    },
    cancel(key) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        target.edit = false;
        this.tempDataReceive = newData;
      }
    },
    save(key) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.edit = false;
        delete target.editable;
        this.tempDataReceive = newData;
      }
    },
    getDataReceivePost(val) {
      this.tempDataReceive = val.map((item, index) => {
        //console.log(val)
        return {
          key: item.id_dtl,
          no: index + 1,
          item_pn: item.item_pn,
          kd_anggaran: item.kode_anggaran,
          dtl_pp_nm: item.nama_dtl_pp,
          item_name: item.nama_barang,
          quantity: item.jumlah,
          satuan: item.satuan,
          gudang_name: null,
          gudang_id: null,
          unit_kelola_id: null,
          unit_kelola_name: null,
          tlc_name: null,
          tlc: null,
          edit: false,
          item_name_receive: null,
          item_pn_receive: null,
          id_po_dtl: item.id_dtl,
          price_receive: item.type_item ? (item.type_item=="1" ? item.harga_terima : 0) : 0,
          price: item.type_item ? (item.type_item=="1" ? item.harga_terima : 0) : 0,
          unit_receive: item.satuan,
          type_item: item.type_item ? item.type_item : "0",

        };
      });
    },
    handleShipmentStatusPo(values, table) {
      let formData = new FormData();
      formData.append("id_po", this.id);
      formData.append("tlc", this.getAuth.username);
      formData.append("shipment_status", "Received");
      formData.append(
        "tgl_terima",
        moment(values.tgl_terima, this.getDefaultDateFormat).format(
          this.getStandartFormatDate
        )
      );
      // formData.append(
      //   "tgl_terima",
      //   moment(this.dataShipmentReceive.tgl_terima, this.getDefaultDateFormat).format(
      //     this.getStandartFormatDate
      //   )
      // );
      formData.append("surat_jalan", values.surat_jalan);
      // formData.append("surat_jalan", this.dataShipmentReceive.surat_jalan);

      if (this.visibleShipmentReceive) {
        formData.append("po_deli_id", this.dataShipmentReceive.po_deli_id);
      }

      if (values.note) {
        formData.append("note", values.note);
      } else {
        formData.append("note", "");
      }
      table.forEach((item) => {
        formData.append("jumlah[]", item.quantity);
        formData.append(
          "id_gudang[]",
          item.gudang_id ? item.gudang_id : item.tlc
        );
        formData.append("item_pn[]", item.item_pn_receive);
        formData.append("nama_barang[]", item.item_name_receive);
        formData.append("id_po_dtl[]", item.id_po_dtl);
        formData.append("price[]", item.price);
        formData.append("unit[]", item.unit);
      });

      Axios({
        method: "post",
        url: this.$serviceUrl + "po/penerimaan",
        processData: false,
        data: formData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.visibleShipmentReceive = false;
          this.displayMessage("success-send");
          this.$router.go(0);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    openWindowCopy(link, noResi) {
      const me = this;
      this.$copyText(noResi).then(
        function (e) {
          // this.displayMessageValue("success-copy-resi",e.text);
          me.displayMessageValue("success-copy-resi", e.text);
          window.open(link, "_blank");
        },
        function (e) {
          alert("Can not copy");
        }
      );
    },
    handleSelectedStorage(val) {
      let selectDAset = _.filter(
          this.tempDataReceive,
          (el) => el.type_item=="0"
        );

      if (val !== undefined) {
        if(selectDAset.length>0){
          this.tempDataReceive.map((item) => {
            if(item.type_item=="0"){
              item.gudang_id = val.key;
              item.gudang_name = val.label;

              item.tlc = undefined;
              item.tlc_name = undefined;
              item.unit_kelola_id = undefined;
              item.unit_kelola_name = undefined;
            }
          });
          this.allowEditModal = true;
          this.enabledEditDtl = true;
        }else{
          this.displayMessageValue(
            "basic-error",
            "Data don't set, No item type on data list!"
          );
        }
      } 
      // else {
      //   this.tempDataReceive.map((item) => {
      //     if(item.type_item=="0"){
      //     item.gudang_id = undefined;
      //     item.gudang_name = undefined;

      //     item.item_pn_receive = undefined;
      //     item.item_name_receive = undefined;
      //     item.price = 0;
      //     item.price_receive = 0;
      //     item.unit = item.satuan;
      //     }
      //   });
      //   this.allowEditModal = false;
      //   this.enabledEditDtl = false;
      // }
    },
    handleSelectedUnitKelola(val){
      let selectDAset = _.filter(
          this.tempDataReceive,
          (el) => el.type_item=="1"
        );

      if (val !== undefined) {
        if(selectDAset.length>0){
          this.tempDataReceive.map((item) => {
            if(item.type_item=="1"){
              item.unit_kelola_id = val.key;
              item.unit_kelola_name = val.label;

              item.tlc = undefined;
              item.tlc_name = undefined;
              item.gudang_id = undefined;
              item.gudang_name = undefined;

               item.item_pn_receive = undefined;
                item.item_name_receive = undefined;
                //item.price = 0;
                //item.price_receive = 0;
                item.unit = item.satuan;
            }
          });
          this.allowEditModal = true;
          this.enabledEditDtl = true;
        }else{
          this.displayMessageValue(
            "basic-error",
            "Data don't set, No item type on data list!"
          );
        }
      } 
      // else {
      //   this.tempDataReceive.map((item) => {
      //     if(item.type_item=="1"){
      //       item.unit_kelola_id = undefined;
      //       item.unit_kelola_name = undefined;
      //       item.tlc = undefined;
      //       item.tlc_name = undefined;
      //       item.gudang_id = undefined;
      //       item.gudang_name = undefined;

      //       item.item_pn_receive = undefined;
      //       item.item_name_receive = undefined;
      //       item.price = 0;
      //       item.price_receive = 0;
      //       item.unit = item.satuan;
      //     }
      //   });
      //   this.allowEditModal = false;
      //   this.enabledEditDtl = false;
      // }
    },
    handleSelectedStoragetlc(val) {
      let ismaset = this.isAssetModal=="yes" ? "1" :"0";
      //let ismaset = val.isAssetModals;
      //val = val.val;
      let selectDAset = _.filter(
          this.tempDataReceive,
          (el) => el.type_item==ismaset
        );
      
      if (val !== undefined) {
          if(selectDAset.length>0){
            this.tempDataReceive.map((item) => {
              if(item.type_item==ismaset){
                item.tlc = val.key;
                item.tlc_name = val.label;

                item.unit_kelola_id = undefined;
                item.unit_kelola_name = undefined;
                item.gudang_id = undefined;
                item.gudang_name = undefined;

                item.item_pn_receive = undefined;
                item.item_name_receive = undefined;
                item.price = 0;
                item.price_receive = 0;
                item.unit = item.satuan;
              }
            });
            this.allowEditModal = true;
            this.enabledEditDtl = true;
          }else{
            this.displayMessageValue(
              "basic-error",
              "Data don't set, No item type on data list!"
            );
          }
        } 
        // else {
        //   this.tempDataReceive.map((item) => {
        //     if(item.type_item==ismaset){
        //       item.tlc = undefined;
        //       item.tlc_name = undefined;
        //       item.unit_kelola_id = undefined;
        //       item.unit_kelola_name = undefined;
        //       item.gudang_id = undefined;
        //       item.gudang_name = undefined;

        //       item.item_pn_receive = undefined;
        //       item.item_name_receive = undefined;
        //       item.price = 0;
        //       item.price_receive = 0;
        //       item.unit = item.satuan;
        //     }
        //   });
        // this.allowEditModal = false;
        // this.enabledEditDtl = false;
        // }
    },
    handleViews(val) {
      if (val.rest_api === "supplier") {
        let namemanifest = null;
        if (this.getNavigation[0].divisi === "Akuntansi") {
          namemanifest = "SpclSupplierManifestAcc";
        } else {
          namemanifest = "manifestPurchasing";
        }
        this.$router.push({
          name: namemanifest,
          params: {
            id: val.id_manifest,
            tlc: this.getAuth.username,
            user_pembuat: val.user_pembuat,
          },
        });
      } else {
        this.handleView(val);
      }
    },
    selectRadioUsedFor(e) {
      if (e.target.value === "gudang") {
        this.formShipmentReceive.setFieldsValue({ gudang_default: undefined });
        this.handleSelectedStorage(undefined);
      } else if(e.target.value === "unitkelola"){
        this.formShipmentReceive.setFieldsValue({ pengelola_default: undefined });
        this.handleSelectedUnitKelola(undefined);
      }else {
        this.formShipmentReceive.setFieldsValue({ tlc_default: undefined });
        this.handleSelectedStoragetlc(undefined);
      }
    },
    selectIsAssetModal(e){
      if (e.target.value === "yes") {
        this.formShipmentReceive.setFieldsValue({ gudang_default: undefined });
        this.formShipmentReceive.setFieldsValue({ pengelola_default: undefined });
        this.usedfor = 'unitkelola';
      } else {
        this.formShipmentReceive.setFieldsValue({ tlc_default: undefined });
        this.formShipmentReceive.setFieldsValue({ pengelola_default: undefined });
        this.usedfor = 'gudang';
      }
    },
    selectRadioUsedForReceive(e) {
      if (e.target.value === "tlcreceive") {
        this.editReceiveDtl.opsi = "tlcreceive";
        this.editReceiveDtl.idgudang = undefined;
        this.editReceiveDtl.gudang_name = undefined;
        this.editReceiveDtl.unit_kelola_id = undefined;
        this.editReceiveDtl.unit_kelola_name = undefined;
      } else if (e.target.value === "unitkelola"){
        this.editReceiveDtl.opsi = "unit_kelola";
        this.editReceiveDtl.tlc = undefined;
        this.editReceiveDtl.tlc_name = undefined;
        this.editReceiveDtl.gudang_name = undefined;
        this.editReceiveDtl.unit_kelola_id = undefined;
      }else {
        this.editReceiveDtl.opsi = "gudangreceive";
        this.editReceiveDtl.tlc = undefined;
        this.editReceiveDtl.tlc_name = undefined;
        this.editReceiveDtl.unit_kelola_id = undefined;
        this.editReceiveDtl.unit_kelola_name = undefined;
      }
    },
    handleOk() {
      this.formeditRowDtl.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (
          (values.usedforReceive == "gudangreceive" || values.usedforReceive ==="unitkelola") &&
          parseInt(values.qtydtl) > 0 &&
          (this.selectedPN == null && this.selectedPNAset == null)
        ) {
          this.displayMessageValue(
            "basic-error",
            "Please Select Item Receive!"
          );
          return;
        }
        
        if (values.usedforReceive === "gudangreceive") {
          let gdng = _.filter(
            this.daftarGudang,
            (nav) => nav.gudang_id.indexOf(values.gudangEditDtl) >= 0
          );
          this.editReceiveDtl.idgudang = gdng[0].gudang_id;
          this.editReceiveDtl.gudang_name = gdng[0].gudang_nm;
        } else if(values.usedforReceive ==="unitkelola"){
          let unt = _.filter(
            this.daftarUnitKelola,
            (nav) => nav.aset_unit_id.indexOf(values.unitkelolaEditDtl) >= 0 
          );
          this.editReceiveDtl.unit_kelola_id = unt[0].aset_unit_id;
          this.editReceiveDtl.unit_kelola_name = unt[0].aset_unit_nm;
        }else {
          let tlc = _.filter(
            this.getAllKaryawan,
            (nav) => nav.tlc.indexOf(values.tlcEditDtl) >= 0
          );
          this.editReceiveDtl.tlc_name = tlc[0].tlc + " - " + tlc[0].nama;
          this.editReceiveDtl.tlc = tlc[0].tlc;
        }
        this.editReceiveDtl.price_receive = values.unitpricedtl ? values.unitpricedtl : 0;

        const index = this.tempDataReceive.findIndex(
          (x) => x.key === this.editReceiveDtl.key
        );
        
        this.tempDataReceive[index].quantity = values.qtydtl;
        this.tempDataReceive[index].unit_kelola_id = null;
        this.tempDataReceive[index].unit_kelola_name = null;
        this.tempDataReceive[index].gudang_id = null;
        this.tempDataReceive[index].gudang_name = null;
        this.tempDataReceive[index].tlc = null;
        this.tempDataReceive[index].tlc_name = null;
        this.tempDataReceive[index].unit = values.unitmasterdtl ? values.unitmasterdtl : '';
        this.tempDataReceive[index].price = values.unitpricedtl ? values.unitpricedtl : 0;
        if (values.usedforReceive === "gudangreceive") {
          this.tempDataReceive[index].item_name_receive = this.selectedPN
            ? this.selectedPN.item_nm
            : null;
          this.tempDataReceive[index].item_pn_receive = this.selectedPN
            ? this.selectedPN.item_pn
            : null;
            this.tempDataReceive[index].gudang_id = this.editReceiveDtl.idgudang;
            this.tempDataReceive[index].gudang_name = this.editReceiveDtl.gudang_name;
        }else if(values.usedforReceive ==="unitkelola"){
          if (this.selectedPNAset.aset_pn){
            this.tempDataReceive[index].item_name_receive = this.selectedPNAset
              ? this.selectedPNAset.aset_nm
              : null;
            this.tempDataReceive[index].item_pn_receive = this.selectedPNAset
              ? this.selectedPNAset.aset_pn
              : null;
          }else{
            this.tempDataReceive[index].item_name_receive = this.selectedPNAset.item_pn_concat;
            this.tempDataReceive[index].item_pn_receive = values.PNAset;
          }
          this.tempDataReceive[index].unit_kelola_id = this.editReceiveDtl.unit_kelola_id;
          this.tempDataReceive[index].unit_kelola_name = this.editReceiveDtl.unit_kelola_name;
          this.tempDataReceive[index].gudang_id = this.tempDataReceive[index].unit_kelola_id;
          this.tempDataReceive[index].gudang_name = this.tempDataReceive[index].unit_kelola_name;
        }else{
          this.tempDataReceive[index].tlc = this.editReceiveDtl.tlc;
          this.tempDataReceive[index].tlc_name = this.editReceiveDtl.tlc_name;
          this.tempDataReceive[index].item_name_receive = null
          this.tempDataReceive[index].item_pn_receive = null
        }
        this.selectedPNAset = null;
        this.selectedPN = null;
        
        this.visibleEditDtl = false;
      });
    },
    handleCancelDtl() {
      this.visibleEditDtl = false;
    },
    filterOptionGudang(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionTlc(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionTlcdtl(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionGudangdtl(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionUnitkelola(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "po",
        id_manifest: this.id,
        code_trans: this.data.manifest.no_po,
        kode_project: this.data.manifest.kode_project,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "editPo",
        params: { id: this.id, type: "revised" },
      });
    },
    handleViewFile: function (item) {
      const data = {
        id_manifest: item.id_account_pay,
        rest_api: "accountpay",
      };
      this.handleView(data);
    },
    handlePNitem(value) {
      const filter = _.filter(this.dataPNitem, (item) => {
        if (item.item_pn === (value ? value.item_pn : null)) {
          this.editReceiveDtl.unit_receive = item.satuan;
          return item;
        }
      });
    },
    handlePNAset(value) {
      if((value && !value.aset_pn) || value==null){
        this.formeditRowDtl.setFieldsValue({ PNAset: null });
      }else {
        this.formeditRowDtl.setFieldsValue({ PNAset: value.aset_pn });
      }
    },
    getPNitem(params) {
      Axios({
        method: "get",
        url: this.$serviceUrl + "po/assistPN",
        params: {
          filterString: params ? params : "",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataPNitem = response.data.listPN;
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-aktif-project");
        });
    },
    getPNAset(params) {
      Axios({
        method: "get",
        url: this.$serviceUrl + "po/asetPN",
        params: {
          filterString: params ? params : "",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataPNAset = response.data.listPN;
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-other","Error get PN Aset");
        });
    },
    handleclosetrans (){
      this.visiblemenupopover  = false;
      this.visibleCloseForm    = true;
      
      this.loadtableclose      = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "po/close_po",
        params: {
          id_po : this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (response.data.data){
            this.tableClosepo = response.data;
          }else{
            this.visibleCloseForm = false;
           this.displayMessageValue("success-other", response.data.message);
           this.$router.go(0);
          }
          this.loadtableclose=false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChangeClosepo (value, key, column) {
      const newData = [...this.tableClosepo.data]
      const target = newData.filter(item => key === item.id_pp_dtl)[0]
      if (target) {
        target[column] = value
        this.tableClosepo.data = newData
      }
      if(this.tempvalClosepo.toFixed(2)==this.tableClosepo.sisa_transfer.toFixed(2)){
        this.disabledClosetranspo=false;
      }else{
        this.disabledClosetranspo=true;
      }
    },
    saveCloseForm(){
      let formData = new FormData();
      formData.append("id_po", this.id);
      formData.append("tlc", this.getAuth.username);
      this.tableClosepo.data.forEach((item) => {
        formData.append("id_pp_dtl[]", item.id_pp_dtl);
        formData.append("value[]", item.value);
      });
      Axios({
        method: "post",
        url: this.$serviceUrl + "po/close_po",

        data: formData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.$router.go(0);
          this.displayMessage("success");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleViewclosetrans(){
      this.visibleCloseFormview = true;
    },
    valueFromChild(value) {
      if (this.receiveModal.steps[this.receiveModal.current].content === "InformasiReceive") {
        this.dataShipmentReceive.note = value.values.note;
        this.dataShipmentReceive.tgl_terima = value.values.tgl_terima;
        this.isAssetModal = "no";
        this.receiveModal.current++;
        if (this.receiveModal.qtyItem==0){
          this.receiveModal.current++;
        }
      } else if (this.receiveModal.steps[this.receiveModal.current].content === "ReceiveItem") {
        this.isAssetModal = "yes";
        this.receiveModal.current++;
      }else{
        this.handleShipmentStatusReceive();
      }
    },
    nextStepReceive(){
      if (this.receiveModal.steps[this.receiveModal.current].content === "InformasiReceive") {
        this.$refs.refInformasi.handleRef();
      } else if (this.receiveModal.steps[this.receiveModal.current].content === "ReceiveItem") {
        if (this.receiveModal.qtyAset==0){
          this.handleShipmentStatusReceive();
        }else{
          this.$refs.refItem.handleRef();
        }
      } else {
        this.$refs.refAset.handleRef();
      }
    },
    validateStepReceive(){
      this.handleShipmentStatusReceive();
    },
    prevStepReceive(){
      if (this.receiveModal.steps[this.receiveModal.current].content === "ReceiveAset") {
        this.isAssetModal = "no";
        if (this.receiveModal.qtyItem==0){
          this.receiveModal.current--;
        }
      }
      this.receiveModal.current--;
    },
    handleviewhistPaymentrefund(){
      this.modalhistPaymentrefund = true;
    },
  },
  mounted() {
    this.fetchManifest();
    this.fetchShipment();
    // Event.$on("confirmMessageReturn", this.handleShipmentStatus);
    Event.$on("confirmMessageAddDetil", this.handleShipmentStatus);
    Event.$on("confirmMessageAddDetilPo", this.handleShipmentStatusPo);
    Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageReturn", this.handleAction);
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("poReceiveItemAset", this.valueFromChild);
    Event.$on("poReceivehandleSelectedStorage", this.handleSelectedStorage);
    Event.$on("poReceivehandleSelectedUnitKelola", this.handleSelectedUnitKelola);
    Event.$on("poReceivehandleSelectedStoragetlc", this.handleSelectedStoragetlc);
    Event.$on("poReceivehandleEditPopover", this.handleEditPopover);
  },
  beforeDestroy() {
    // Event.$off("confirmMessageReturn", this.handleShipmentStatus);
    Event.$off("confirmMessageAddDetil", this.handleShipmentStatus);
    Event.$off("confirmMessageAddDetilPo", this.handleShipmentStatusPo);
    Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageReturn", this.handleAction);
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("poReceiveItemAset", this.valueFromChild);
    Event.$off("poReceivehandleSelectedStorage", this.handleSelectedStorage);
    Event.$off("poReceivehandleSelectedUnitKelola", this.handleSelectedUnitKelola);
    Event.$on("poReceivehandleSelectedStoragetlc", this.handleSelectedStoragetlc);
    Event.$on("poReceivehandleEditPopover", this.handleEditPopover);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
        this.reqFileTf = true;
        this.search = "";
      }
    },
    histpaymentRefundsearch() {
      if (this.histpaymentRefundsearch) {
        this.histpaymentData = this.histpaymentDatatemp.filter(
          (obj) =>
            obj.nama_barang.toLowerCase().indexOf(this.histpaymentRefundsearch.toLowerCase()) >= 0
        );
      }

      if (!this.histpaymentRefundsearch) {
        this.histpaymentData = this.histpaymentDatatemp;
      }

      return this.tableData;
    },
  },
};
</script>

<style>
.m-select > div {
  height: auto;
}
</style>
